import { makeStyles } from 'tss-react/mui';

export default makeStyles({ name: 'Tag' })({
    root: {
        display: 'block',
        padding: '4px 8px',
        borderRadius: 96,
        fontSize: 14,
        fontWeight: 500,
        lineHeight: '16px',
        background: '#F8F8F8',
        color: '#8E8E8E',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        textDecoration: 'none',
        transition: 'color 0.25s',
        cursor: 'pointer',
        ['&:hover']: {
            color: '#232323'
        }
    }
});
